import { Directive } from '@angular/core';

@Directive({
  selector: '[xpo-small-button], [xpoSmallButton]',
  host: {
    class: 'xpo-SmallButton',
  },
})
export class XpoSmallButton {}
